import styled from 'styled-components';

export const NextShiftMessage = styled.span`
  color: white;
  font-size: 5vw;
  font-weight: 900;
  line-height: 1.2;
`;
